import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { SatelliteTaskView } from "./SatelliteTaskView";
import { SatelliteTaskViewStore } from "../../store/SatelliteTaskViewStore";
import { useStore } from "../../../../hooks";

export const SatelliteTaskViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/satelliteTask/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new SatelliteTaskViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <SatelliteTaskView satelliteTaskViewStore={store} />
      </PageLayout>
    </div>
  );
});
